import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Sin protocolo claro',
  desc: 'En riesgo suicida, agitación o psicosis aguda.'
}, {
  emoji: '📋',
  title: 'Documentás a las corridas',
  desc: 'Sin plantillas que te protejan desde el primer minuto.'
}, {
  emoji: '⚖️',
  title: 'No dominás la Ley 26.657',
  desc: 'Plazos, juez, habeas corpus: zona gris.'
}, {
  emoji: '📚',
  title: 'Libros densos e inútiles',
  desc: 'Nada práctico para tu realidad de guardia.'
}, {
  emoji: '💊',
  title: 'Dudas farmacológicas',
  desc: 'Sin referencia rápida en el momento crítico.'
}, {
  emoji: '🧠',
  title: 'Memorizás, no documentás',
  desc: 'Tu criterio clínico queda sin protección legal.'
}, {
  emoji: '🚨',
  title: 'Exposición legal invisible',
  desc: 'Documentación incompleta = matrícula en riesgo.'
}, {
  emoji: '🩺',
  title: 'Cero manejo institucional',
  desc: 'Jefatura, enfermería, sistema: nadie te enseña.'
}];
export function PainPoints() {
  return <section className="py-8 md:py-20 bg-brand-bg" data-id="element-174">
      <div className="max-w-5xl mx-auto px-4" data-id="element-175">
        <div className="text-center mb-6 md:mb-12" data-id="element-176">
          <h2 className="text-[11px] md:text-sm font-bold text-brand-mid tracking-wider uppercase mb-1.5" data-id="element-177">
            REALIDAD DE GUARDIA
          </h2>
          <h3 className="font-heading text-[22px] md:text-4xl text-brand-dark mb-2 md:mb-4" data-id="element-178">
            ¿TE PASA ESTO?
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto text-xs md:text-base leading-snug" data-id="element-179">
            Si trabajás en hospital público argentino, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-2.5 md:gap-6 mb-6 md:mb-12" data-id="element-180">
          {pains.map((pain, idx) => <div key={idx} className="bg-white p-3 md:p-5 rounded-xl shadow-sm border border-transparent hover:border-brand-dark hover:shadow-md hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-200 flex items-start gap-2.5 md:gap-4 cursor-pointer group" data-id="element-181">
              <div className="text-2xl md:text-4xl shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-182">
                {pain.emoji}
              </div>
              <div className="min-w-0" data-id="element-183">
                <h4 className="font-bold text-gray-900 mb-0.5 md:mb-1 text-[13px] md:text-base leading-tight" data-id="element-184">
                  {pain.title}
                </h4>
                <p className="text-gray-600 text-[11px] md:text-sm line-clamp-2 leading-snug" data-id="element-185">
                  {pain.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center max-w-3xl mx-auto bg-white p-4 md:p-6 rounded-2xl border border-red-100 shadow-sm" data-id="element-186">
          <p className="text-sm md:text-xl font-heading text-brand-dark leading-snug" data-id="element-187">
            ¿Cuántas guardias más sin un sistema que respalde cada decisión y te
            blinde legalmente?
          </p>
        </div>
      </div>
    </section>;
}